import PropTypes from 'prop-types';
import { useCallback } from 'react';

import Button from 'shared/components/button/Button';
import UpdateIcon from 'shared/components/icon/Update';
import SelectInput from 'shared/components/input/SelectInput';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

const PointReductionToolbar = ({
  index,
  betType,
  isInternationalRace,
  isLocked,
  pointSource = '',
  onChange,
}) => {
  const options = [['toolbar-point-choose', '']];
  if (IS_SE_SITE && betType === 'T') {
    options.push(['toolbar-point-pointastrioindex', 'pointAsTrioIndex', true]);
  }
  if (betType === 'T' || betType === 'FIVEPLUS') {
    options.push(['toolbar-point-pointasodds', 'pointAsOdds', true]);
  } else {
    if (betType !== 'LD' && betType !== 'DD') {
      options.push(
        ['toolbar-point-pointaspercent', 'pointAsPercent', true],
        ['toolbar-point-pointasinsats30m', 'pointAsInsats30m', true],
        ['toolbar-point-pointasinsats1t', 'pointAsInsats1t', true],
        ['toolbar-point-pointasinsats2t', 'pointAsInsats2t', true],
        ['toolbar-point-pointasrank', 'pointAsRank', true],
      );
    }
    options.push(
      ['toolbar-point-pointasodds', 'pointAsOdds', true],
      [
        'toolbar-point-pointaswinnerpercentranking',
        'pointAsWinnerPercentRanking',
      ],
      ['toolbar-point-pointasearningsranking', 'pointAsEarningsRanking'],
    );
    if (!isInternationalRace) {
      options.push([
        'toolbar-point-pointasstartpointranking',
        'pointAsStartPointRanking',
      ]);
    }
    options.push(
      [
        'toolbar-point-pointasearningsperstartranking',
        'pointAsEarningsPerStartRanking',
      ],
      ['toolbar-point-pointasrecordtimeranking', 'pointAsRecordTimeRanking'],
    );
    if (betType !== 'LD' && betType !== 'DD') {
      options.push(['toolbar-point-pointasownwin', 'pointAsOwnWin', true]);
    }
  }
  options.push(['toolbar-point-reset', 'reset']);

  const updateVisible = options.find(option => option[1] === pointSource)[2];

  const handleChange = useCallback(
    e => {
      if (e.target.value === '') {
        return;
      }
      onChange(e.target.value, index);
    },
    [index, onChange],
  );

  const handleUpdate = useCallback(() => {
    onChange(pointSource, index);
  }, [index, onChange, pointSource]);

  return (
    <div className={styles.wrapper}>
      <SelectInput
        className={styles.select}
        disabled={isLocked}
        onChange={handleChange}
        value={pointSource}
        width="220"
      >
        {options.map(([text, value]) => (
          <option key={text} value={value}>
            {getText(text)}
          </option>
        ))}
      </SelectInput>

      {updateVisible && (
        <Button
          disabled={isLocked}
          className={styles.btn}
          onClick={handleUpdate}
        >
          <UpdateIcon className={styles.icon} />
          {getText('button-update')}
        </Button>
      )}
    </div>
  );
};

PointReductionToolbar.propTypes = {
  index: PropTypes.number,
  isInternationalRace: PropTypes.bool,
  isLocked: PropTypes.bool,
  pointSource: PropTypes.string,

  onChange: PropTypes.func,
};

export default PointReductionToolbar;
